import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ECR } from '../models/ecr';
import { Employee } from '../models/employee.model';
import { CrudService } from './crud.service';
//import {ECR} from '../models/ecr';

@Injectable({
  providedIn: 'root'
})
export class ECRService {

  constructor(private crudService: CrudService) { }

  PostECR(ecrmodel: FormData): Observable<any> {
    return this.crudService.post('ecr/PostManualEcr', ecrmodel);
  }

  // getEmpList(sbu: string, department: string): Observable<Employee[]> {
  //   const fd = new FormData();
  //   fd.append('BU', sbu);
  //   fd.append('Department', department);
  //   return this.crudService.postThr<[]>('employees', { BU: sbu, Department: department });
  // }

  getEmpList(sbu: string, department: string): Observable<Employee[]> {
    const fd = new FormData();
    fd.append('BU', sbu);
    fd.append('Department', department);
    return this.crudService.get<[]>('ecr/GetAllEmployees?BU=' + sbu + '&Department=' + department);
  }



  postEcr(ecr: any): Observable<Employee[]> {
  const monthMap: any = {
    january: 1, february: 2, march: 3, april: 4, may: 5, june: 6,
    july: 7, august: 8, september: 9, october: 10, november: 11, december: 12
  };

  const payload: any = {
    Month: ecr.month ? monthMap[ecr.month.toLowerCase()] : null,
    Year: ecr.year,
    BusinessUnit: ecr.sbu.code,
    Department: ecr.department.departmentmaster.departmentName, 
    TmcIds: ecr.employee
  };

  // null/empty keys hata do
  Object.keys(payload).forEach(key => {
    if (payload[key] === null || payload[key] === "") {
      delete payload[key];
    }
  });

  console.log("Final API Payload:", payload);
  return this.crudService.post('ECR/GetECRReport', payload);
}





  getHolidays(branchCode: string, year: string, month?: string): Observable<any> {
    return this.crudService.postBam<[]>('holiday', {
      "BranchCode": branchCode,
      "Month": month,
      "Year": year
    });
  }

  GetReporteeECR(TMC: string, month: number, Year: number): Observable<any> {
    return this.crudService.get<any>('Profile/GetReporteeECRLatest?tmcid=' + TMC + "&month=" + month + "&Year=" + Year);
  }

  getDeptList(sbu): Observable<[]> {
    const fd = new FormData();
    //fd.append('SBU', sbu);
    return this.crudService.postBam<[]>('department', { SBU: sbu });
  }

  SaveECRFiles(ecrmodel: FormData): Observable<any> {
    return this.crudService.post('ecr/PostECRFiles', ecrmodel);
  }

  GetECRByTMC(TMC: any): Observable<any> {
    return this.crudService.get<any>('ecr/GetEcrByTMC?TMCNo=' + TMC);
  }

  DeleteECRFiles(TMC: any, EcrDate: string, FileName: string): Observable<any> {
    return this.crudService.get<any>('ecr/DeleteECRFiles?TMCNo=' + encodeURIComponent(TMC) +
      "&ECRDate=" + encodeURIComponent(EcrDate) + "&FileName=" + encodeURIComponent(FileName));
  }
  DeleteECRFilesDateWise(TMC: any, EcrDate: string): Observable<any> {
    return this.crudService.get<any>('ecr/DeleteECRFilesDateWise?TMCNo=' + encodeURIComponent(TMC) +
      "&ECRDate=" + encodeURIComponent(EcrDate));
  }

  GetAllFilesByEcrDate(TMC: any, EcrDate: any): Observable<any> {
    return this.crudService.get<any>('ecr/GetAllFilesByEcrDate?TmcNo=' + encodeURIComponent(TMC) +
      "&EcrDate=" + encodeURIComponent(EcrDate));
  }

  SaveFEmailSetting(TMC: any, FavEmails: any, Defaultemail: any): Observable<any> {
    return this.crudService.get<any>('ecr/PostEmailSettings?TMCNo=' + TMC +
      '&DefaultEmails=' + Defaultemail + '&FavEmails=' + FavEmails);
  }

  GetEmailSettings(TMC: any): Observable<any> {
    return this.crudService.get<any>('ecr/GetEmailSettings?TMCNo=' + TMC);
  }

  GetECRByTMCAndMonth(TMC: any, Month: any): Observable<any> {
    return this.crudService.get<any>('ecr/GetEcrByTMCAndMonth?TMCNo=' + TMC + '&Month=' + Month);
  }

  GetECRByTMCAndMonthCalender(TMC: any, Month: any, Year: any): Observable<any> {
    return this.crudService.get<any>('ecr/GetEcrByTMCAndMonthCalender?TMCNo=' + TMC + '&Month=' + Month + '&Year=' + Year);
  }

  GeServerDate(): Observable<any> {
    return this.crudService.get<any>('ecr/GetServerDate');
  }
  GetEmployees(): Observable<any> {
    return this.crudService.get<any>('ecr/GetEmployeesList');
  }
  GetEmployeesListBySearch(searchString: string): Observable<any> {
    return this.crudService.get<any>('Ecr/GetEmployeesList?search=' + searchString);
  }
  GetReportingHeadDetails(TmcNo: string): Observable<any> {
    return this.crudService.get<any>('ecr/GetReportingHeadDetails?TmcNo=' + TmcNo);
  }

  GetSBUHeadDetails(SBUCode: string): Observable<any> {
    return this.crudService.get<any>('ecr/GetSBUHeadDetails?SBUCode=' + SBUCode);
  }

  GetEmployeeInformation(TmcNo: string): Observable<any> {
    return this.crudService.get<any>('ecr/GetEmployeeDetails?TmcNo=' + TmcNo);
  }
  GetMasters(): Observable<any> {
    return this.crudService.get<any>('ecr/GetMasters');
  }
  GetHRECR(SBU: string, Department: string, month: any, year: any, EmpId: string): Observable<any> {
    return this.crudService.get<any>('ecr/GetHREcr?SBU=' + SBU + '&Department=' + Department + "&month=" + month + "&year=" + year + "&TMCNo=" + EmpId);
  }
  GetECRDocsByTMC(TmcNo: string, EcrDate: string): Observable<any> {
    return this.crudService.get<any>(
      'ecr/GetEcrDocumentsByTMC?TmcNo=' + encodeURIComponent(TmcNo) + '&EcrDate=' + encodeURIComponent(EcrDate)
    );
  }

  getTHREmp(): Observable<any> {
    return this.crudService.get<any>(`Master/GetTHREmpList`);
  }

  getBuWiseHR(userId: any): Observable<Employee[]> {
    const fd = new FormData();
    fd.append('tmcId', userId);
    return this.crudService.post('ecr/GetBUListByTmcId', fd);
  }

  getDepartmentBUwise(userId: any): Observable<Employee[]> {
    const fd = new FormData();
    fd.append('sbuMappingId', userId);
    return this.crudService.post('ecr/GetDepartmentList', fd);
  }
  getSbuList(userId: any): Observable<Employee[]> {
    const fd = new FormData();
    fd.append('buMappingId', userId);
    return this.crudService.post('ecr/GetSBUList', fd);
  }



}
